import type { VoidFunctionComponent } from 'react';

import { window } from '../../../../globals';
import { getBaseOrgProperties, track } from '../../../../helpers/analytics';
import Button from '../../../generic/Button/Button';
import Flex from '../../../generic/Flex';
import { formatIntervalType } from '../utils';

import { usePlansContext } from './PlansContext';
import type { ViewIntervalOptions } from './index';

import styles from './styles.module.less';

type PlansHeaderProps = {
  hideLabel?: boolean,
};

const PlansHeader: VoidFunctionComponent<PlansHeaderProps> = ({ hideLabel }: PlansHeaderProps) => {
  const {
    viewInterval,
    setViewInterval,
  } = usePlansContext();

  const handleChangeViewInterval = (type: ViewIntervalOptions) => {
    setViewInterval(type);
    const formattedType = formatIntervalType(type);
    if (window.user?.organization) {
      track(`Toggle Plans - ${formattedType}`, { ...getBaseOrgProperties(), planType: formattedType });
    }
  };
  return (
    <Flex
      direction="row"
      align="center"
      gap={20}
      className={styles.plansController}
    >
      {
        !hideLabel &&
        <span className={styles.plansControllerTitle}>Change Plan</span>
      }
      <span>
        Billing
      </span>
      <div className={styles.toggleButtonsContainer}>
        <Button
          onClick={() => handleChangeViewInterval('year')}
          type={viewInterval === 'year' ? 'primary' : 'outline'}
          size="large"
        >
          Yearly
        </Button>
        <Button
          onClick={() => handleChangeViewInterval('month')}
          type={viewInterval === 'month' ? 'primary' : 'outline'}
          size="large"
        >
          Monthly
        </Button>
      </div>
    </Flex>
  );
};

export default PlansHeader;
